import { AllocationStatusTypes } from '../../../types/ProjectManagement/EmployeeAllocation/employeeAllocationTypes'

export const filterOptionsStatus: AllocationStatusTypes[] = [
  { label: 'Allocated', value: 'true' },
  { label: 'De-Allocated', value: 'false' },
]
export enum CheckEnum {
  checkAll = 'Check All',
  uncheckAll = 'Uncheck All',
  checkNum = 'Check Num',
  unCheckNum = 'Uncheck Num',
}

export const getStatusListTestId = (value: string): string => {
  return `statuslist-${value}`
}
